import { render, staticRenderFns } from "./MailingCampaignDashboard.vue?vue&type=template&id=51caf678&"
import script from "./MailingCampaignDashboard.vue?vue&type=script&lang=js&"
export * from "./MailingCampaignDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports